import { isDefined } from './helpers';
//https://www.antoniovdlc.me/one-way-state-management-in-vanilla-javascript/
export default function createStore(initialState, reducer) {
    const state = new Proxy(
      { value: initialState },
      {
        set(obj, prop, value) {
          obj[prop] = value;
          updateUI();
        },
      }
    );

    function getState() {
      return { ...state.value };
    }

    function dispatch(action) {
      const prevState = getState();
      state.value = reducer(prevState, action);
    }

    function getTotals() {
        const { price, frais, taxe, days, person, options } = getState();
        const TotalNuit = Number(price);
        const TotalTaxe = Number(taxe * person * days);
        const TotalOptions = options.reduce((acc, option) => {
            return acc + Number(option.price);
        }, 0);

        return Number(TotalNuit + TotalTaxe + frais + TotalOptions);
    }

    return {
      getState,
      dispatch,
      getTotals
    };
}

function updateUI()
{
    const person = document.querySelector('#person') || null;
    if((person)) person.innerHTML = store.getState().person;
    const taxe = document.querySelector('#taxe') || null;
    if((taxe)) taxe.innerHTML = computedPrice((store.getState().taxe * store.getState().person * store.getState().days), 2);
    const total = document.querySelector('#total') || null;
    if((total)) total.innerHTML = computedPrice(store.getTotals(), 2);
    const option = document.querySelector('#option-list') || null;
    if((option))
    {
        const options = store.getState().options;
        if(options.length > 0)
        {
            let html = '';
            options.forEach(option => {
                html += '<li class="">'
                html += option.label;
                html += '</li>';
            });
            option.innerHTML = html;
        }
        else
        {
            option.innerHTML = '<li class="">Aucune option sélectionnée</li>';
        }
    }
}

function computedPrice(price, decimals = 0)
{
    if(!isDefined(price)) return;
    if(decimals != 0) return new Number(price / 100).toFixed(decimals) + '€';
    return new Number(price / 100).toFixed(0) + '€';
}
